import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Building2, Loader2, Plus } from 'lucide-react'
import { API_ROUTES, apiFetch } from '@/config/api-routes'

interface Resumo {
  total: number
  ativos: number
  suspensos: number
}

export default function AdminDashboardPage() {
  const [resumo, setResumo] = useState<Resumo | null>(null)
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState<string | null>(null)

  useEffect(() => {
    apiFetch(API_ROUTES.admin.workspaces)
      .then(r => r.json())
      .then(j => {
        if (j.error) throw new Error(j.error)
        setResumo(j.resumo)
      })
      .catch(e => setErro(e instanceof Error ? e.message : 'Erro ao carregar'))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <header style={{ marginBottom: 24 }}>
        <h1 className="page-title">Dashboard</h1>
        <p className="page-subtitle" style={{ margin: 0 }}>
          Provisionamento de médicos e workspaces do Médico 360.
        </p>
      </header>

      {loading ? (
        <div className="card" style={{ padding: 32, textAlign: 'center', color: 'var(--muted)' }}>
          <Loader2 size={22} style={{ animation: 'spin 1s linear infinite' }} aria-hidden />
        </div>
      ) : erro ? (
        <div className="field-error" role="alert">{erro}</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 24 }}>
          {[
            { label: 'Workspaces', value: resumo?.total ?? 0, icon: Building2 },
            { label: 'Ativos', value: resumo?.ativos ?? 0 },
            { label: 'Suspensos', value: resumo?.suspensos ?? 0 },
          ].map(c => (
            <div key={c.label} className="card" style={{ padding: '18px 16px' }}>
              <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 6 }}>{c.label}</div>
              <div style={{ fontSize: 28, fontWeight: 800 }}>{c.value}</div>
            </div>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Link to="/admin/medicos/novo" className="btn-primary">
          <Plus size={16} aria-hidden /> Provisionar médico
        </Link>
        <Link to="/admin/medicos" className="btn-secondary">
          Ver todos os workspaces
        </Link>
      </div>
    </div>
  )
}
